function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "transparent",
  width: 283.464,
  height: 283.464
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 141.616,
  cy: 72.122,
  r: 35.917
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "infobody",
  x: 104.119,
  y: 113.498,
  fill: "#FFFFFF",
  width: 74.346,
  height: 130.915
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M105.529,113.472H92.948c12.088,11.76,11.118,18.324,11.118,18.324L105.529,113.472z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M106.165,244.42H88.739c16.743-16.288,15.399-25.38,15.399-25.38L106.165,244.42z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M176.33,244.42h17.425c-16.742-16.288-15.398-25.38-15.398-25.38L176.33,244.42z"
});

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 284,
    height: 284,
    viewBox: "-0.006 -0.052 284 284",
    enableBackground: "new -0.006 -0.052 284 284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.0a8824e4.svg";
export { ForwardRef as ReactComponent };